import * as React from "react";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../utils/Helpers";
export var LanguageChangeButton = function (_a) {
    var focusRaw = _a.focusRaw, _b = _a.authScreen, authScreen = _b === void 0 ? false : _b;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return i18n.changeLanguage(i18n.language === "ka" ? "en" : "ka"); },
    });
    return (React.createElement("button", { tabIndex: 0, ref: ref, className: "language-change-btn" },
        React.createElement("span", null, authScreen
            ? t("auth_tv.language-btn")
            : t("layout.languages." + (i18n.language === "ka" ? "en" : "ka")))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageChangeButton.tsx
// module id = 39
// module chunks = 1